export default __webpack_public_path__ + "static/Persona-Adam-bb15628a5293c635c091aee08bc707a3.png";